import type { QueryClient } from '@tanstack/react-query';

/**
 * Refetches all purchase request related queries
 * Call this function after any mutation that affects purchase requests
 *
 * @example
 * // In a mutation's onSuccess callback:
 * onSuccess: () => {
 *   refetchAllQueries(queryClient);
 * }
 */
export function refetchAllQueries(queryClient: QueryClient): void {
  const queriesToRefetch = [
    'RequestsToday',
    'TopSuppliers',
    'Request-Day',
    'All-Requests',
    'Pending-Approval-Requests',
    'Active-Requests',
    'Canceled-Requests',
    'request',
  ];

  // Invalidate all the specified queries
  queriesToRefetch.forEach((queryKey) => {
    queryClient.invalidateQueries({ queryKey: [queryKey] });
  });

}
